import { render, staticRenderFns } from "./ProductDrawer.vue?vue&type=template&id=47d0e88c&scoped=true"
import script from "./ProductDrawer.vue?vue&type=script&lang=js"
export * from "./ProductDrawer.vue?vue&type=script&lang=js"
import style0 from "./ProductDrawer.vue?vue&type=style&index=0&id=47d0e88c&prod&lang=scss&scoped=true"
import style1 from "./ProductDrawer.vue?vue&type=style&index=1&id=47d0e88c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d0e88c",
  null
  
)

export default component.exports